import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import "./Header.css";
import { useLocation, Link, NavLink } from "react-router-dom";
import ar from '../../assets/ar.pdf';
import en from '../../assets/en.pdf';
import logo from "../../assets/logo.svg";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import axios from 'axios';
import SearchComponent from "../ui/home/Search";
import { FaFileAlt, FaFilePdf } from 'react-icons/fa';
import LanguageSwitcher from "../ui/home/language-changer";
import { useLanguage } from "../../store/language-context";
import { useTranslation } from "react-i18next";

export default function Header() {
  const { URL } = useLanguage();
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [services, setServices] = useState([]);

  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
  const location = useLocation();

  useEffect(() => {
    setIsLoggedIn(localStorage.getItem('isLoggedIn') === 'true');
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(`${URL}/services`);
        if (response.data && response.data.data) {
          const fetchedServices = response.data.data.data;
          setServices(fetchedServices);
        } else {
          console.error('Invalid API response structure:', response);
        }
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    };

    fetchServices();
  }, [URL]); // Only fetch services once on component mount

  useEffect(() => {
    // Close the menu when the route changes
    setIsMenuOpen(false);
  }, [location]); // Close menu when the route changes

  const handleLinkClick = () => {
    setIsMenuOpen(false);  // Close menu when a link is clicked
  };

  const serviceRoutes = {
    1: 'training',
    2: 'consulting',
    3: 'coaching',
    4: 'platforms',
    5: 'evaluate',
    
    6: 'training-kits',
    7: 'learning-solutions',
    8: 'sector',
    9: 'leadership-solutions'

  };

  return (
    <header className="header-container w-full">

      <div className=" bg-[#722f37] py-2 max-lg:px-4 up-header">
        <div className="container">
          <div className="flex justify-between items-center w-full text-white max-lg:text-sm max-md:flex-wrap max-md:flex-col" >
            <div className="flex items-center gap-1 mt-2">
              <NavLink to='/privacy' className={'text-white'}>{t('routes.privacy-policy')}</NavLink>
              <span className="separator me-2 ms-2">|</span>
              <NavLink to='/contactus' className={'text-white'}>{t('routes.contact-us')}</NavLink>
            </div>
            <div className="flex items-center gap-1 mt-2">
              {isLoggedIn ? (
                <Dropdown>
                  <Dropdown.Toggle variant="link" id="user-dropdown" className="login-btn">
                    <FaUserCircle size={24} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="/profile">{t('routes.profile')}</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      onClick={() => {
                        localStorage.removeItem('isLoggedIn');
                        localStorage.removeItem('token');
                        localStorage.removeItem('userEmail');
                        sessionStorage.clear();
                        setIsLoggedIn(false);
                        window.location.reload();
                      }}
                    >
                      {t('custom.logout')}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <Link to="/login" className="login-btn">
                  <FaUserCircle size={24} />  {t('routes.login')}
                </Link>
              )}
              <Link to={ar} target='_blank' className="login-btn">
                {t('ar')} <FaFilePdf className="img-fluid" />
              </Link>
              <Link to={en} target='_blank' className="login-btn">
                English <FaFileAlt className="img-fluid" />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <nav className="main-nav">
          <a href="/" className="logo">
            <img src={logo} alt="Logo" />
          </a>

          <div className="nav text-nowrap">
            <div className={`nav-links ${isMenuOpen ? "active" : ""}`}>
              <NavLink to='/'>{t('routes.home')}</NavLink>
              <NavLink to="/about">{t('routes.about-ivory')}</NavLink>
              <DropdownButton id="dropdown-basic-button" title={t('routes.services')} className="mr-2 w-sm-100 w-lg-auto">
                {/* {services.length > 0 ? (
                  services.map((service) => (
                    <Dropdown.Item
                      key={service.id}
                      href={`/services/${serviceRoutes[service.id]}`}
                      onClick={handleLinkClick}
                    >
                      {service.title}
                    </Dropdown.Item>
                  ))
                ) : (
                )} */}
                <>
                  <Dropdown.Item as="a" href="/services/training" rel="noopener noreferrer">
                    {t('routes.training')}
                  </Dropdown.Item>
                  <Dropdown.Item as="a" href="/services/learning-solutions" rel="noopener noreferrer">
                    {t('routes.learning-solutions')}
                  </Dropdown.Item>
                  <Dropdown.Item as="a" href="/services/evaluate" rel="noopener noreferrer">
                    {t('routes.evaluate')}
                  </Dropdown.Item>
                  <Dropdown.Item as="a" href="/services/consulting" rel="noopener noreferrer">{t('routes.consulting')}</Dropdown.Item>
                  <Dropdown.Item as="a" href="/services/coaching" rel="noopener noreferrer">{t('routes.coaching')}</Dropdown.Item>
                  <Dropdown.Item as="a" href="/services/training-kits" rel="noopener noreferrer">{t('routes.training-kits')}</Dropdown.Item>
                  <Dropdown.Item as="a" href="/services/platforms" rel="noopener noreferrer">{t('routes.platforms')}</Dropdown.Item>
                  <Dropdown.Item as="a" href="/services/third-sector" rel="noopener noreferrer">{t('routes.third-sector')}</Dropdown.Item>
                  <Dropdown.Item as="a" href="/services/leasership-development" rel="noopener noreferrer">{t('routes.leadership-solutions')}</Dropdown.Item>
                </>
              </DropdownButton>
              <NavLink to="/training-courses?page=1" >
                {t('routes.training-courses')}
              </NavLink>
              <NavLink to="/dependencies">
                {t('routes.accreditations')}
              </NavLink>


              <NavLink to="/training-plan">
                {t('routes.training-plan')}
              </NavLink>
              <NavLink to="/seminars">
                {t('routes.seminars')}
              </NavLink>

              <div className="relative w-full lg:hidden">
                <SearchComponent />
              </div>
            </div>


          </div>
          <div className="flex items-end justify-center max-lg:hidden ">
            <SearchComponent />
            {/* <LanguageSwitcher/> */}
          </div>

          <button className="menu-toggle z-[1000]" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X size={24} color="black" /> : <Menu size={24} color="black" />}
          </button>
        </nav>
      </div>

    </header>
  );
}
